import React, { useState, useEffect, useRef, useContext, useCallback } from "react";
import default_vertical_img from "../../assets/placehoder_vertical.png";
import { Translate } from "../../components/LanguageChanger";
import premium from "../../assets/Premium.png";
import rent from "../../assets/Rent.png";
import upcomingImg from "../../assets/upcoming.png";
import imgLive from "../../assets/img_live.gif";
import $ from "jquery";
import Wrapper from "../../components/shared/Wrapper";
import { sendTestMatomoEvent } from "../../Analytics/MatomoManager/matomoTest";
import { AppContext } from "../../AppContext";

let deviceType = window.DEVICE_TYPE;

// --- 1. CSS Styles for Shimmer Effect ---
const shimmerStyles = `
  /* 1. Standard Keyframes */
  @keyframes shimmerAnimation {
    0% { transform: translateX(-100%); }
    100% { transform: translateX(100%); }
  }
  
  /* 2. WebKit Keyframes (REQUIRED for Old Samsung/LG) */
  @-webkit-keyframes shimmerAnimation {
    0% { -webkit-transform: translateX(-100%); }
    100% { -webkit-transform: translateX(100%); }
  }
  
  .shimmer-container {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.05);
    border-radius: 10px;
    overflow: hidden;
    
    /* Force GPU Acceleration (Helps prevent lag on low-end TVs) */
    transform: translateZ(0);
    -webkit-transform: translateZ(0);
  }

  .shimmer-effect {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    
    /* 3. Old WebKit Gradient Syntax (For Old TVs) */
    background: -webkit-linear-gradient(
      left, 
      transparent 0%, 
      #000037 50%, 
      transparent 100%
    );

    /* 4. Standard Gradient Syntax */
    background: linear-gradient(
      90deg, 
      transparent 0%, 
      #000037 50%, 
      transparent 100%
    );

    /* 5. Animation with WebKit prefix */
    -webkit-animation: shimmerAnimation 1.5s infinite linear;
    animation: shimmerAnimation 1.5s infinite linear;
    
    z-index: 1;
  }
`;

// --- 2. Helper Component: ShimmerImage ---
const ShimmerImage = ({ src, alt, style, onClick, onErrorFallback }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  // CLEANUP FIX: Track if component is mounted to prevent state updates after unmount
  const isMountedRef = useRef(true);

  // CLEANUP FIX: Set mounted flag to false on unmount
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const handleLoad = useCallback(() => {
    // CLEANUP FIX: Only update state if component is still mounted
    if (isMountedRef.current) {
      setIsLoaded(true);
    }
  }, []);

  const handleError = useCallback(() => {
    // CLEANUP FIX: Only update state if component is still mounted
    if (isMountedRef.current) {
      setHasError(true);
      setIsLoaded(true);
    }
  }, []);

  return (
    <div className="shimmer-container" style={{ ...style, position: "relative" }}>
      {/* Show Shimmer if not loaded and no error */}
      {!isLoaded && !hasError && <div className="shimmer-effect"></div>}

      <img
        src={hasError ? onErrorFallback : src}
        alt={alt}
        onClick={onClick}
        onLoad={handleLoad}
        onError={handleError}
        style={{
          width: "100%",
          height: "100%",
          borderRadius: "10px",
          objectFit: "cover",
          opacity: isLoaded ? 1 : 0,
          transition: "opacity 0.5s ease-in-out",
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 2,
        }}
      />
    </div>
  );
};

const LiveEventCustomMarkupGrid = ({
  screen,
  isBackButtonSelected,
  handleMarkupGridDownButton,
  rowWidth,
  rowHeight,
  gapBetweenRow,
  columnWidth,
  columnHeight,
  gapBetweenColumn,
  itemWidth,
  itemHeight,
  numRows,
  fontSize,
  fontColor,
  selectionStyle,
  numColumns,
  shouldFocus,
  data,
  marginLeft,
  marginTop,
  rowBgColor,
  rowBgImage,
  columnBgImage,
  columnBgColor,
  selectionColor,
  gapBetweenCatTitleAndItemList,
  animationSpeed,
  handleBackButton,
  handleMarkupGridUPButton,
  IsLiveEvent,
  handleLeft,
  isLogedIn,
  handleMarkupGridOKButton,
  handLeMarkupGridLeftButton,
  rememberRowFocus,
  setRememberRowFocus,
  rememberColFocus,
  setRememberColFocus,
}) => {
  console.log(rememberRowFocus, rememberColFocus);
  const [selectedRowIndex, setSelectedRowIndex] = useState(
    rememberRowFocus > 0 ? rememberRowFocus : 0
  );
  const [selectedColumnIndex, setSelectedColumnIndex] = useState(
    rememberColFocus > 0 ? rememberColFocus : 0
  );
  const [startIndexes, setStartIndexes] = useState([]);
  const { sourceContext, setSourceContext } = useContext(AppContext);
  const [scrolling, setScrolling] = useState(false);
  const gridRef = useRef(null);
  const isInitialMount = useRef(true);
  const page = localStorage.getItem("pageName");

  // CLEANUP FIX: Track mounted state to prevent operations on unmounted component
  const isMountedRef = useRef(true);
  
  // CLEANUP FIX: Store animation timeout IDs for cleanup
  const timeoutIdsRef = useRef([]);
  
  // CLEANUP FIX: Track active jQuery animations for proper cleanup
  const activeAnimationsRef = useRef([]);

  // CLEANUP FIX: Helper to add timeout that will be cleaned up on unmount
  const addManagedTimeout = useCallback((callback, delay) => {
    const timeoutId = setTimeout(() => {
      // Remove from tracking array when it executes
      timeoutIdsRef.current = timeoutIdsRef.current.filter(id => id !== timeoutId);
      if (isMountedRef.current) {
        callback();
      }
    }, delay);
    timeoutIdsRef.current.push(timeoutId);
    return timeoutId;
  }, []);

  // CLEANUP FIX: Helper to stop jQuery animation and track it
  const animateElement = useCallback((element, properties, duration, onComplete) => {
    // Stop any existing animation on this element
    $(element).stop(true, false);
    
    const $element = $(element);
    activeAnimationsRef.current.push($element);
    
    $element.animate(properties, duration, function() {
      // Remove from active animations
      activeAnimationsRef.current = activeAnimationsRef.current.filter(el => el[0] !== element);
      
      // Only call onComplete if component is still mounted
      if (isMountedRef.current && onComplete) {
        onComplete();
      }
    });
  }, []);

  // CLEANUP FIX: Main cleanup effect - runs on unmount
  useEffect(() => {
    return () => {
      // Mark component as unmounted
      isMountedRef.current = false;
      
      // Clear all pending timeouts
      timeoutIdsRef.current.forEach(timeoutId => {
        clearTimeout(timeoutId);
      });
      timeoutIdsRef.current = [];
      
      // Stop all active jQuery animations to prevent memory leaks
      activeAnimationsRef.current.forEach($element => {
        $element.stop(true, true);
      });
      activeAnimationsRef.current = [];
      
      // Clean up grid ref if it exists
      if (gridRef.current) {
        $(gridRef.current).stop(true, true);
      }
    };
  }, []);

  useEffect(() => {
    if (shouldFocus && gridRef.current) {
      gridRef.current.focus();
    }
  }, [shouldFocus]);

  useEffect(() => {
    // Initialize with remembered positions or defaults
    const initialRowIndex =
      rememberRowFocus > 0 ? Math.min(rememberRowFocus, data.length - 1) : 0;
    const initialColIndex =
      rememberColFocus > 0
        ? Math.min(
            rememberColFocus,
            (data[initialRowIndex]?.shows?.length || 1) - 1
          )
        : 0;

    setSelectedRowIndex(initialRowIndex);
    setSelectedColumnIndex(initialColIndex);

    // Calculate initial start indexes for each row
    const newStartIndexes = data.map((row, index) => {
      if (index === initialRowIndex && rememberColFocus > 0) {
        return Math.max(
          0,
          Math.min(
            rememberColFocus - Math.floor(numColumns / 2),
            row?.shows?.length - numColumns
          ) 
        );
      }
      return 0;
    });

    setStartIndexes(newStartIndexes);

    // CLEANUP FIX: Use managed timeout instead of raw setTimeout
    if (isInitialMount.current && rememberRowFocus > 0 && gridRef.current) {
      addManagedTimeout(() => {
        if (!gridRef.current) return; // Additional safety check
        
        // Scroll vertically to show the remembered row
        const scrollTop = initialRowIndex * (rowHeight + 0);
        animateElement(gridRef.current, { scrollTop: scrollTop }, 0);

        // Scroll horizontally to show the remembered column if needed
        if (rememberColFocus > 0) {
          const rowElement = document.getElementById(`row-${initialRowIndex}`);
          if (rowElement) {
            const scrollLeft =
              newStartIndexes[initialRowIndex] * (columnWidth + gapBetweenColumn);
            animateElement(rowElement, { scrollLeft: scrollLeft }, 0);
          }
        }
      }, 100);
    }

    isInitialMount.current = false;
  }, [data, numRows, rememberRowFocus, rememberColFocus, addManagedTimeout, animateElement, rowHeight, columnWidth, gapBetweenColumn, numColumns]);

  // CLEANUP FIX: Stabilize handler functions using useCallback to prevent recreations
  const handleOk = useCallback(() => {
    const currentCategory = data[selectedRowIndex];
    if (gridRef.current) {
      gridRef.current.blur();
    }

    console.log("handleOk", data[selectedRowIndex]?.title?.[0]?.content);

    if (typeof setRememberRowFocus === "function") {
      setRememberRowFocus(selectedRowIndex);
    }
    if (typeof setRememberColFocus === "function") {
      setRememberColFocus(selectedColumnIndex);
    }

    handleMarkupGridOKButton(currentCategory?.shows[selectedColumnIndex]);
    
    // Adding sourceContext Live
    if (currentCategory?.genres_id === null) {
      setSourceContext(
        `${sourceContext}/(${currentCategory?.id}/${currentCategory?.title?.[0]?.content})`
      );
    } else {
      setSourceContext(
        `${sourceContext}/(${currentCategory?.shows[0]?.id}/${currentCategory?.shows?.[0]?.title})`
      );
    }
  }, [data, selectedRowIndex, selectedColumnIndex, setRememberRowFocus, setRememberColFocus, handleMarkupGridOKButton, sourceContext, setSourceContext]);

  const selectedOK = useCallback((rowIndex, columnIndex) => {
    const currentCategory = data[rowIndex];
    const selectedShow = currentCategory?.shows[columnIndex];

    if (gridRef.current) {
      gridRef.current.blur();
    }

    if (typeof setRememberRowFocus === "function") {
      setRememberRowFocus(rowIndex);
    }
    if (typeof setRememberColFocus === "function") {
      setRememberColFocus(columnIndex);
    }

    handleMarkupGridOKButton(selectedShow);
  }, [data, setRememberRowFocus, setRememberColFocus, handleMarkupGridOKButton]);

  const scrollHorizontal = useCallback((direction, nextIndex) => {
    const rowElement = document.getElementById(`row-${selectedRowIndex}`);
    if (!rowElement) return;
    
    const currentRow = $(rowElement);
    const distance = columnWidth + gapBetweenColumn;
    const newStartIndexes = [...startIndexes];
    const currentStartIndex = newStartIndexes[selectedRowIndex];

    setScrolling(true);

    if (direction === "right") {
      const nextStartIndex = currentStartIndex + 1;
      if (nextStartIndex + numColumns <= data[selectedRowIndex]?.shows?.length) {
        animateElement(
          rowElement,
          { scrollLeft: `+=${distance}` },
          animationSpeed,
          () => {
            if (isMountedRef.current) {
              newStartIndexes[selectedRowIndex] = nextStartIndex;
              setStartIndexes(newStartIndexes);
              setSelectedColumnIndex(nextIndex);
              setScrolling(false);
            }
          }
        );
      } else {
        setScrolling(false);
      }
    } else if (direction === "left") {
      const prevStartIndex = currentStartIndex - 1;
      if (prevStartIndex >= 0) {
        animateElement(
          rowElement,
          { scrollLeft: `-=${distance}` },
          animationSpeed,
          () => {
            if (isMountedRef.current) {
              newStartIndexes[selectedRowIndex] = prevStartIndex;
              setStartIndexes(newStartIndexes);
              setSelectedColumnIndex(nextIndex);
              setScrolling(false);
            }
          }
        );
      } else {
        setScrolling(false);
      }
    }
  }, [selectedRowIndex, columnWidth, gapBetweenColumn, startIndexes, numColumns, data, animationSpeed, animateElement]);

  const scrollVertical = useCallback((direction) => {
    if (!gridRef.current) return;
    
    const distance = rowHeight + gapBetweenRow;
    setScrolling(true);

    if (direction === "down") {
      animateElement(
        gridRef.current,
        { scrollTop: `+=${distance}` },
        animationSpeed,
        () => {
          if (isMountedRef.current) {
            setScrolling(false);
          }
        }
      );
    } else if (direction === "up") {
      animateElement(
        gridRef.current,
        { scrollTop: `-=${distance}` },
        animationSpeed,
        () => {
          if (isMountedRef.current) {
            setScrolling(false);
          }
        }
      );
    }
  }, [rowHeight, gapBetweenRow, animationSpeed, animateElement]);

  const handleRightKey = useCallback((currentCategory, rowLength) => {
    const nextIndex = selectedColumnIndex + 1;
    if (nextIndex < rowLength) {
      if (nextIndex >= startIndexes[selectedRowIndex] + numColumns) {
        scrollHorizontal("right", nextIndex);
      } else {
        setSelectedColumnIndex(nextIndex);
      }
    }
  }, [selectedColumnIndex, startIndexes, selectedRowIndex, numColumns, scrollHorizontal]);

  const handleLeftKey = useCallback(() => {
    const prevIndex = selectedColumnIndex - 1;
    if (prevIndex >= 0) {
      if (prevIndex < startIndexes[selectedRowIndex]) {
        scrollHorizontal("left", prevIndex);
      } else {
        setSelectedColumnIndex(prevIndex);
      }
    } else if (selectedColumnIndex === 0 && !IsLiveEvent) {
      if (handleLeft !== false && gridRef.current) {
        gridRef.current.blur();
        handleBackButton();
      }
    }
  }, [selectedColumnIndex, startIndexes, selectedRowIndex, IsLiveEvent, handleLeft, handleBackButton, scrollHorizontal]);

  const handleDownKey = useCallback(() => {
    if (selectedRowIndex < data.length - 1) {
      const nextRowIndex = selectedRowIndex + 1;
      const newColumnIndex = 0;

      setSelectedRowIndex(nextRowIndex);
      setSelectedColumnIndex(newColumnIndex);

      // Reset horizontal scroll position for the new row to ensure first item is visible
      const newStartIndexes = [...startIndexes];
      if (newStartIndexes[nextRowIndex] !== 0) {
        newStartIndexes[nextRowIndex] = 0;
        setStartIndexes(newStartIndexes);
        
        // Smoothly scroll the row back to the start
        const nextRowElement = document.getElementById(`row-${nextRowIndex}`);
        if (nextRowElement) {
          animateElement(nextRowElement, { scrollLeft: 0 }, animationSpeed);
        }
      }

      if (gridRef.current) {
        const rowTop = nextRowIndex * (rowHeight + gapBetweenRow);
        const containerHeight = gridRef.current.clientHeight;
        const rowBottom = rowTop + rowHeight;

        if (rowBottom > gridRef.current.scrollTop + containerHeight) {
          scrollVertical("down");
        }
      }
    } else if (screen === "liveEvent") {
      console.log("handleMarkupGridDownButton..");
      if (isBackButtonSelected) setSelectedRowIndex(0);
      handleMarkupGridDownButton();
    }
  }, [selectedRowIndex, data.length, startIndexes, animationSpeed, rowHeight, gapBetweenRow, screen, isBackButtonSelected, handleMarkupGridDownButton, scrollVertical, animateElement]);

  const handleUpKey = useCallback(() => {
    if (selectedRowIndex > 0) {
      const prevRowIndex = selectedRowIndex - 1;
      const prevRowLength = data[prevRowIndex]?.shows?.length || 0;
      const newColumnIndex =
        selectedColumnIndex < prevRowLength
          ? selectedColumnIndex
          : prevRowLength - 1;
      
      setSelectedRowIndex(prevRowIndex);
      setSelectedColumnIndex(newColumnIndex);

      // Reset horizontal scroll position for the previous row to ensure focused item is visible
      const newStartIndexes = [...startIndexes];
      const targetStartIndex = Math.max(
        0,
        Math.min(
          newColumnIndex - Math.floor(numColumns / 2),
          prevRowLength - numColumns
        )
      );
      
      if (newStartIndexes[prevRowIndex] !== targetStartIndex) {
        newStartIndexes[prevRowIndex] = targetStartIndex;
        setStartIndexes(newStartIndexes);
        
        // Smoothly scroll to show the focused item
        const prevRowElement = document.getElementById(`row-${prevRowIndex}`);
        if (prevRowElement) {
          const scrollLeft = targetStartIndex * (columnWidth + gapBetweenColumn);
          animateElement(prevRowElement, { scrollLeft: scrollLeft }, animationSpeed);
        }
      }

      if (gridRef.current) {
        const rowTop = prevRowIndex * (rowHeight + gapBetweenRow);
        if (rowTop < gridRef.current.scrollTop) {
          scrollVertical("up");
        }
      }
    } else {
      handleMarkupGridUPButton();
    }
  }, [selectedRowIndex, selectedColumnIndex, data, startIndexes, numColumns, columnWidth, gapBetweenColumn, animationSpeed, rowHeight, gapBetweenRow, handleMarkupGridUPButton, scrollVertical, animateElement]);

  const handleKeyDown = useCallback((e) => {
    if (scrolling) return;
    const currentCategory = data[selectedRowIndex];
    const rowLength = currentCategory?.shows?.length;

    switch (e.keyCode) {
      case 39:
        handleRightKey(currentCategory, rowLength);
        break;
      case 37:
        handleLeftKey();
        break;
      case 40:
        
        handleDownKey();
        break;
      case 38:
       
        handleUpKey();
        break;
      case 13:
        handleOk();
        break;
      case 8:
      case 10009:
      case 461:
        if (gridRef.current) {
          gridRef.current.blur();
        }
        handleBackButton();
        break;
      default:
        break;
    }
  }, [scrolling, data, selectedRowIndex, handleRightKey, handleLeftKey, handleDownKey, handleUpKey, handleOk, handleBackButton]);

  function capitalizeFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  return (
    <>
      {/* Inject CSS Styles */}
      <style>{shimmerStyles}</style>

      <div
        ref={gridRef}
        style={{
          width: "100vw",
          height: "79vh",
          marginLeft: marginLeft,
          marginTop: marginTop,
          overflow: "auto",
          outline: "none",
          display: "flex",
          flexDirection: "column",
          position: "relative",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
        tabIndex="0"
        onKeyDown={handleKeyDown}
      >
        {data.map((category, rowIndex) => {
          const isSelectedRow = rowIndex === selectedRowIndex;
          return (
            <div
              key={category.genres_id ? category.genres_id : ""}
              style={{
                marginBottom: gapBetweenRow,
                backgroundImage: `url(${rowBgImage})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
              }}
            >
              <div
                style={{
                  fontSize: fontSize,
                  color: fontColor,
                  marginBottom: gapBetweenCatTitleAndItemList,
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                }}
              >
                {(() => {
                  const title =
                    category?.genres_name === "genres"
                      ? category?.list[0]?.genres
                      : category?.genres_name === "recent"
                      ? "Recent Live"
                      : category?.title?.find(
                          (item) =>
                            item.language ===
                            (localStorage.getItem("AppLanguage") || "English")
                        )?.content ||
                        category?.title?.find(
                          (item) => item.language === "English"
                        )?.content ||
                        category?.genres_name;

                  const translatedTitles = [
                    "Recent Live",
                    "Up Coming",
                    "Live Now",
                  ];

                  if (translatedTitles.includes(title)) {
                    return <Translate langKey={title} />;
                  }

                  return capitalizeFirstLetter(title);
                })()}
              </div>
              <div
                id={`row-${rowIndex}`}
                style={{
                  display: "flex",
                  overflow: "hidden",
                  width: rowWidth,
                  height: columnHeight,
                  position: "relative",
                }}
              >
                {category?.shows
                  .slice(
                    startIndexes[rowIndex],
                    startIndexes[rowIndex] + numColumns
                  )
                  .map((show, columnIndex) => {
                    const absoluteColumnIndex =
                      startIndexes[rowIndex] + columnIndex;
                    const isSelected =
                      isSelectedRow && absoluteColumnIndex === selectedColumnIndex;

                    return (
                      <div
                        key={show.id || columnIndex}
                        style={{
                          width: columnWidth,
                          height: columnHeight,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginRight:
                            columnIndex < numColumns - 1 ? gapBetweenColumn : 0,
                          backgroundImage: `url(${columnBgImage})`,
                          borderRadius: "10px",
                        }}
                      >
                        <Wrapper
                          onMouseEnter={() => {
                            if (shouldFocus) {
                              setSelectedRowIndex(rowIndex);
                              setSelectedColumnIndex(absoluteColumnIndex);
                            }
                          }}
                          style={{
                            width: itemWidth,
                            height: itemHeight,
                            width: "100%",
                            height: "98%",
                            lineHeight: `${itemHeight}px`,
                            textAlign: "center",
                            backgroundColor:
                              selectionStyle === "background" && isSelected
                                ? selectionColor
                                : "transparent",
                            border:
                              selectionStyle === "border" && isSelected
                                ? `5px solid ${selectionColor}`
                                : "5px transparent",
                            transform:
                              selectionStyle === "zoom" && isSelected
                                ? "scale(1.1)"
                                : "scale(1)",
                            transition: "transform 0.3s",
                            boxSizing: "border-box",
                            cursor: "pointer",
                            borderRadius: "10px",
                            fontSize: fontSize,
                            color: fontColor,
                            backgroundPosition: "center",
                            position: "relative",
                            left: "0.2rem",
                          }}
                        >
                          <div
                            style={{
                              position: "relative",
                              height: "100%",
                              width: "100%",
                              borderRadius: "10px",
                              overflow: "hidden"
                            }}
                            onMouseEnter={() => {
                              if (shouldFocus) {
                                setSelectedRowIndex(rowIndex);
                                setSelectedColumnIndex(absoluteColumnIndex);
                              }
                            }}
                          >
                            <ShimmerImage
                              src={
                                show.thumbnail || default_vertical_img
                              }
                              onErrorFallback={default_vertical_img}
                              alt={show.title}
                              onClick={() =>
                                selectedOK(rowIndex, absoluteColumnIndex)
                              }
                              style={{
                                width: "100%",
                                height: "100%",
                              }}
                            />

                            {show?.is_live == 1 && (
                              <img
                                src={imgLive}
                                alt="live Icon"
                                style={{
                                  position: "absolute",
                                  bottom: "14rem",
                                  left: "0.7rem",
                                  width: "5rem",
                                  height: "2rem",
                                  top: "0.7rem",
                                  zIndex: 3,
                                }}
                              />
                            )}

                            {category?.genres_name == "upcoming" && (
                              <img
                                src={upcomingImg}
                                alt={show.title}
                                style={{
                                  borderRadius: "10px",
                                  position: "absolute",
                                  width: "7vw",
                                  height: "4vh",
                                  top: "1vh",
                                  right: "0.7rem",
                                  zIndex: 3,
                                }}
                                onClick={() =>
                                  selectedOK(rowIndex, absoluteColumnIndex)
                                }
                              />
                            )}

                            {show?.is_paid === 1 && (
                              <img
                                src={premium}
                                alt="Premium Icon"
                                style={{
                                  position: "absolute",
                                  top: "10px",
                                  right: "10px",
                                  width: "4rem",
                                  height: "4rem",
                                  zIndex: 3,
                                }}
                              />
                            )}

                            {show?.is_paid === 2 && (
                              <img
                                src={rent}
                                alt="Rent Icon"
                                style={{
                                  position: "absolute",
                                  top: "10px",
                                  right: "10px",
                                  width: "4rem",
                                  height: "4rem",
                                  zIndex: 3,
                                }}
                              />
                            )}

                            {show.isTeaser === 1 &&
                              (() => {
                                const startTime =
                                  parseInt(show?.endtime) * 1000;
                                const now = Date.now();
                                const hoursRemaining =
                                  (startTime - now) / (1000 * 60 * 60);
                                const launchesIn24Hours =
                                  startTime > 0 && startTime < window.CWPOOLING;

                                return launchesIn24Hours ? (
                                  <div
                                    style={{
                                      position: "absolute",
                                      bottom: "10%",
                                      left: "50%",
                                      transform: "translateX(-50%)",
                                      zIndex: 10,
                                      background: "#fff",
                                      color: "black",
                                      padding: "5px 15px",
                                      fontSize: "16px",
                                      fontWeight: "bold",
                                      whiteSpace: "nowrap",
                                      textTransform: "uppercase",
                                    }}
                                  >
                                    {`LAUNCHES IN ${Math.ceil(
                                      hoursRemaining
                                    )} HOURS`}
                                  </div>
                                ) : null;
                              })()}
                            {show?.isTeaser === 1 && (
                              <img
                                src={upcomingImg}
                                alt={show.title}
                                style={{
                                  borderRadius: "10px",
                                  position: "absolute",
                                  width: "10vw",
                                  height: "4vh",
                                  top: "1vh",
                                  right: "1rem",
                                  zIndex: 3,
                                }}
                              />
                            )}
                          </div>
                        </Wrapper>
                      </div>
                    );
                  })}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default LiveEventCustomMarkupGrid;